<i18n>
{
	"en": {
		"label": "Trip Search Preview",
		"fromLocation": "From Location",
		"toLocation": "To Location",
		"tripType": "Trip Type",
		"cargoCarrier": "Cargo Carrier",
		"status": "Status",
		"allLocations": "All locations",
		"allTripTypes": "All trip types",
		"allStatuses": "All statuses",
		"allCargoCarriers": "All cargo carriers",
		"cancelled": "Cancelled",
		"draft": "Draft",
		"received": "Received",
		"rejected": "Rejected",
		"ready": "Ready",
		"planned": "Planned",
		"unsuccessful": "Unsuccessful",
		"requested": "Requested",
		"accepted": "Accepted",
		"selectStatus": "Select status",
		"readyForPickup": "Ready for pickup",
		"loaded": "Loaded",
		"unloaded": "Unloaded",
		"linehaul": "Linehaul",
		"distribution": "Distribution",
		"external": "External"
	},
	"no": {
		"label": "Tursøk forhåndsvisning",
		"fromLocation": "Fra sted",
		"toLocation": "Til sted",
		"tripType": "Turtype",
		"cargoCarrier": "Lastebærer",
		"status": "Status",
		"allLocations": "Alle steder",
		"allTripTypes": "Alle turtyper",
		"allStatuses": "Alle statuser",
		"allCargoCarriers": "Alle lastebærere",
		"cancelled": "Annullert",
		"draft": "Kladd",
		"received": "Mottatt",
		"rejected": "Avslått",
		"ready": "Klar",
		"planned": "Planlagt",
		"unsuccessful": "Bomtur",
		"requested": "Forespurt",
		"accepted": "Akseptert",
		"selectStatus": "Velg status",
		"readyForPickup": "Klar for henting",
		"loaded": "Lastet",
		"unloaded": "Losset",
		"linehaul": "Langtransport",
		"distribution": "Distribusjon",
		"external": "Ekstern"
	}
}
</i18n>
<template>
	<t-vertical-panel class="filters">
		<div class="label">{{$t('label')}}</div>
		<t-form-group
			:title="$t('fromLocation')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="tripCriteria.fromLocation && hasItems(tripFilter.fromLocation)"
				:items="tripFilter.fromLocation"
				notRemovable
				displayKey="label"
			>
				<template v-slot="{ item }">
					<t-location-tag-inner :item="item" displayKey="label" />
				</template>
			</t-tag-container>
			<div v-else class="all">
				{{ $t('allLocations') }}
			</div>
		</t-form-group>
		<t-form-group
			:title="$t('toLocation')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="tripCriteria.toLocation && hasItems(tripFilter.toLocation)"
				:items="tripFilter.toLocation"
				notRemovable
				displayKey="label"
			>
				<template v-slot="{ item }">
					<t-location-tag-inner :item="item" displayKey="label" />
				</template>
			</t-tag-container>
			<div v-else class="all">
				{{ $t('allLocations') }}
			</div>
		</t-form-group>

		<t-form-group
			:title="$t('tripType')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="tripCriteria.tripType && hasItems(tripFilter.tripType)"
				:items="tripFilter.tripType"
				notRemovable
				displayKey="label"
			>
				<template v-slot="{item}">
					{{$t(item.value)}}
				</template>
			</t-tag-container>
			<div v-else class="all">
				{{ $t('allTripTypes') }}
			</div>
		</t-form-group>
		<t-form-group
			:title="$t('status')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="tripCriteria.status && hasItems(tripFilter.status)"
				:items="tripFilter.status"
				notRemovable
				displayKey="label"
			>
				<template v-slot="{item}">
					<div style="display: flex; align-items: center; justify-content: flex-start;">
						<t-status-color-dot :color="getStatusColor(item)"/>
						<div style="margin-left: 5px;">{{getStatusText(item)}}</div>
					</div>
				</template>
			</t-tag-container>
			<div v-else class="all">
				{{ $t('allStatuses') }}
			</div>
		</t-form-group>
		<t-form-group
			:title="$t('cargoCarrier')"
			rowGap="5px"
			class="filter-group"
		>
			<t-tag-container
				v-if="tripCriteria.cargoCarrier && hasItems(tripFilter.cargoCarrier)"
				:items="tripFilter.cargoCarrier"
				notRemovable
				displayKey="description"
			/>
			<div v-else class="all">
				{{ $t('allCargoCarriers') }}
			</div>
		</t-form-group>
	</t-vertical-panel>
</template>

<script>
import { statuses } from '@/core';

export default {
	name: 'TripFilters',
	props: {
		tripCriteria: Object,
		tripFilter: Object,
	},
	methods: {
		hasItems(array) {
			return array && array.length > 0;
		},
		getStatusText(status) {
			return this.$t(statuses.operational(status));
		},
		getStatusColor(status) {
			return statuses.color(status);
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
.label {
	user-select: none;
	font-size: 14px;
	font-weight: 600;
	line-height: 1.45;
	letter-spacing: 0.3px;
	color: get-color($text, 'dark');
	text-transform: uppercase;
	margin-bottom: 8px;
	margin-left: 1px;
}
.filter-group {
	padding-bottom: 10px;
}
</style>